import React from 'react';
import Page from '../../layout/Page';
import Settings from './Settings';
import Users from './Users';

const ExpressPass = ({ children, ...props }) => {

    return (
        <Page
            title='ExpressPass Management'
            icon='car'
            tabs
        >
            <Users tab='Users' />
            <Settings tab='Settings' />
        </Page >
    );
}

export default ExpressPass;
